<template>
  <div>
    <ul>
      <li>
        <p>公司名称：合肥山河教育科技有限公司</p>
        <p>
          网站名称：山河医学考试网（<a target="_black" href="https://3hvip.com"
            >www.3hvip.com</a
          >）（<a href="/">www.3hvip.cn</a>）
        </p>
        <p>咨询电话：18505513002/18019934025</p>
        <p>投诉电话：18505513002</p>
        <p>咨询时间：全天7*24小时（周六、周日节假日不休息）</p>
        <p>E-mail ：755811231@qq.com</p>
        <p>
          公司地址：安徽省合肥市蜀山区长江西路加侨悦山B栋1401（地铁二号线振兴路A1出口附近）
        </p>
        <div class="map">
          <MapVip />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import MapVip from "../../../components/map/MapVip";
export default {
  components: { MapVip },
  setup() {
    return {};
  },
};
</script>

<style lang="less" scoped>
ul {
  //display: block;
  background: rgb(245, 245, 245);
  width: 580px;
  height: 950px;
  border-radius: 8px;
  margin-bottom: 20px;
  p {
    margin: 10px 15px 10px 15px;
    padding: 10px 10px 15px 10px;
    font-size: 16px;
    a {
      color: @shColor;
    }
  }
  .map {
    width: 580px;
    height: 518px;
  }
}
</style>
